import {useLocation} from "react-router-dom";
import {useMediaQuery} from "@mui/material";
import React, {useEffect, useState} from "react";
import AdsenseComponent from "./AdsenseComponent";
import DotDesktop from "./DotAds";

const adsenseSlots = {
    left: ['3088828307', '6383629579', '8874061540'],
    right: ['3822963730', '4247586670', '5816104627']
}

const DesktopMainBannerAds = () => {
    const location = useLocation();
    const builderPage = location.pathname === '/builder'
    const smallAds = true //useMediaQuery('(max-width: 1900px)') || builderPage
    const ads = useMediaQuery(`(min-width: ${builderPage ? '1750px' : '1580px'})`) && window.config?.aimDownSight

    const [currentBanners, setCurrentBanners] = useState(null)

    useEffect(() => {
        currentBanners == null ? setCurrentBanners(0) : setCurrentBanners((currentBanners + 1) % 3)
        console.log(adsenseSlots.left[currentBanners], adsenseSlots.right[currentBanners])
    }, [location])

    return ads ? <div>
            <div style={{
                position: 'fixed',
                left: `max(0px, calc(((100vw - ${builderPage ? '1268px' : '1100px'}) / 4) - ${smallAds ? '100px' : '150px'}))`,
                top: '20vh',
                height: '800px',
                zIndex: 9999,
                width: smallAds ? '200px' : '300px',
            }}>
                {window.config?.dotDesktop ?
                    <DotDesktop key={`left-${location.key}`} adSlot={window.config?.rightSlot ?? '3'}/> :
                    <AdsenseComponent adClient="ca-pub-9475011578827400" adSlot={adsenseSlots.left[currentBanners]}
                                      adFormat="auto" key={`left-${location.key}`}/>}
            </div>
            <div style={{
                position: 'fixed',
                right: `max(0px, calc(((100vw - ${builderPage ? '1268px' : '1100px'}) / 4) - ${smallAds ? '100px' : '150px'}))`,
                top: '20vh',
                height: '800px',
                zIndex: 9999,
                width: smallAds ? '200px' : '300px',
            }}>
                {window.config?.dotDesktop ?
                    <DotDesktop key={`right-${location.key}`} adSlot={window.config?.leftSlot ?? '4'}/> :
                    <AdsenseComponent adClient="ca-pub-9475011578827400" adSlot={adsenseSlots.right[currentBanners]}
                                      adFormat="auto" key={`right-${location.key}`}/>}
            </div>
        </div>
        : null
}

export default DesktopMainBannerAds